var global = require('../internals/global');
var isPrototypeOf = require('../internals/object-is-prototype-of');

var TypeError = global.TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw TypeError('Incorrect invocation');
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/an-instance.js
// module id = 93
// module chunks = 49